import { css } from '@emotion/react'
import { rem } from '@groovehq/internal-design-system/lib/util/strings'

const container = theme => css`
  width: 100%;
  height: 100%;
  background-color: ${theme.color.monochrome.white};
  padding: ${rem(118)} ${rem(20)} ${rem(60)};
`

const innerContainer = css`
  display: flex;
  justify-content: center;
  align-items: center;
`

const btns = css`
  display: flex;
  margin: ${rem(16)} ${rem(-8)};
  justify-content: center;
  flex-wrap: wrap;
`

const btn = theme => css`
  border-radius: ${rem(24)};
  font-family: ${theme.font.gtWalsheimPro};
  margin: ${rem(8)};
`

const oAuthButtton = theme => css`
  padding-left: ${rem(28)};
  padding-right: ${rem(32)};
  svg {
    border-radius: 50%;
    width: ${rem(32)};
    height: ${rem(32)};
    background-color: ${theme.color.monochrome.white};
    border: 4px solid ${theme.color.monochrome.white};
    margin-right: ${rem(6)};
  }
`

const emailBtn = theme => css`
  padding-left: ${rem(24)};
  padding-right: ${rem(24)};
  font-weight: ${theme.fontWeight.normal};
  color: ${theme.color.info[900]};
`

const content = theme => css`
  max-width: ${rem(530)};
  h2 {
    font-size: ${theme.fontSize.x7large};
    margin-left: ${rem(30)};
    margin-right: ${rem(30)};
  }
  & > p {
    margin-bottom: ${rem(16)};
  }
`

const imgWrapper = css`
  margin-left: ${rem(50)};
  width: ${rem(537)};
  img {
    width: 100%;
  }
`

const demoLink = theme => css`
  all: unset;
  cursor: pointer;
  color: ${theme.color.primary.info};
`

export const styles = {
  container,
  innerContainer,
  btns,
  btn,
  emailBtn,
  oAuthButtton,
  content,
  imgWrapper,
  demoLink,
}
